exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swipe-box {\n  display: block;\n  width: 100%;\n  float: left;\n  margin: 0;\n  -webkit-transform: .5s ease .1s;\n          transform: .5s ease .1s;\n  position: relative; }\n\n.ctn {\n  max-width: 400px;\n  margin: 0 auto; }\n\n.inner-ctn {\n  margin: 20px; }\n\n.visible {\n  display: block; }\n\n.hidden {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/collection-module/view/custom-page/custom-page.component.scss
// module id = ../../../../../src/app/collection-module/view/custom-page/custom-page.component.scss
// module chunks = main